import moment from 'moment';

export const getWeekAgoDate = (): string => {
    const dateFormatString = 'YYYY-MM-DD';
    return moment()
        .subtract(7, 'd')
        .format(dateFormatString);
};

export const openIssuesFlyout = (pushAlert: (type: string, message: string) => void): void => {
    const flyout = window.open(
        '/issues/flyout',
        'IssuesFlyout',
        'scrollbars=1,resizable=0,width=385,height=650',
    );

    if (!flyout) {
        pushAlert(
            'danger',
            'ISSUES FLYOUT: Pop-ups appear to be blocked by the browser. Review your browser settings to allow for the issues flyout.',
        );
    }
};